<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <b-card id="navbar" no-body>
      <b-tabs
        pills
        card
        v-model="tabIndex"
        class="no-padding"
        active-tab-class="nav-basic"
        active-nav-item-class="nav-active"
      >
        <!-- <b-tab slot="tabs-end" title="Análise demográfica"/> -->
        <!--TODO- Retornar active -->
        <b-tab slot="tabs-end" title="Análise por periodo" active />
      </b-tabs>
    </b-card>

    <!--TODO - VOLTAR TAB E SCRIPT -->

    <b-card footer-tag="footer" class="mt-3">
      <b-row>
        <b-col xl="6" lg="6" md="12" sm="12">
          <h4>Periodo de compras</h4>
          <b-input-group prepend="Data Inicial" class="date-input">
            <datepicker
              class="form-control"
              v-model="datainicialcompras"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesStart"
              @selected="mudaDataInicial"
            ></datepicker>
          </b-input-group>
          <b-input-group prepend="Data Final" class="date-input mt-3">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="datafinalcompras"
              :language="ptBR"
              :format="customFormatter"
              @selected="mudaDataFinal"
              :disabledDates="disabledDatesEnd"
            ></datepicker>
          </b-input-group>
        </b-col>

        <b-col xl="6" lg="6" md="12" sm="12">
          <h4>Periodo de ausência</h4>
          <b-input-group prepend="Data Inicial" class="date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="datainicialausente"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesStartAusencia"
              @selected="mudaDataInicialAusencia"
            ></datepicker>
          </b-input-group>
          <b-input-group prepend="Data Final" class="date-input mt-3">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="datafinalausente"
              :language="ptBR"
              :format="customFormatter"
              @selected="mudaDataFinalAusencia"
              :disabledDates="disabledDatesEndAusencia"
            ></datepicker>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" lg="6" md="12" sm="12">
          <b-form-checkbox v-model="compararProdutos" class="mt-4 ml-1" switch
            >Comparar produtos</b-form-checkbox
          >
        </b-col>
        <b-col xl="6" lg="6" md="12" sm="12">
          <b-input-group prepend="Quantidade" class="mt-3">
            <b-form-input
              v-model="quantidadeComparada"
              type="number"
              min="0"
              :disabled="!compararProdutos"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <!-- <b-button variant="danger" class="mt-3 m-w" @click="goBack">Cancelar</b-button> -->
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="success" class="mt-3 m-w" @click="redirect"
            >Confirmar</b-button
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import axios from "axios";
import * as config from "@/config.json";
import Loading from "vue-loading-overlay";

import moment from "moment";

export default {
  components: {
    Datepicker,
    Loading,
    moment,
  },
  data: (_) => {
    return {
      isLoading: false,
      tabIndex: 0,
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      datainicialcompras: null,
      datafinalcompras: null,
      datainicialausente: null,
      datafinalausente: null,
      disabledDatesStartAusencia: null,
      disabledDatesEndAusencia: null,
      compararProdutos: false,
      quantidadeComparada: null,
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async geraAnaliseCompraAusencia() {
      this.isLoading = true;

      const url = `${
        config.default.servidor
      }/gerencial/analise-compra-ausencia/${this.datainicialcompras}/${
        this.datafinalcompras
      }/${this.datainicialausente}/${
        this.datafinalausente
      }/${localStorage.getItem("enterprise_id")}/${
        this.compararProdutos ? this.quantidadeComparada : ""
      }`;

      try {
        const response = await axios({
          url,
          method: "GET",
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw==",
          },
        });

        if (response.status == 200) {
          localStorage.setItem("analise", JSON.stringify(response.data));
          localStorage.setItem(
            "datainicial_compras",
            moment(this.datainicialcompras).format("YYYY-MM-DD")
          );
          localStorage.setItem(
            "datacompra_final",
            moment(this.datafinalcompras).format("YYYY-MM-DD")
          );
          localStorage.setItem(
            "datainicial_compraausencia",
            moment(this.datainicialausente).format("YYYY-MM-DD")
          );
          localStorage.setItem(
            "datafinal_compraausencia",
            moment(this.datafinalausente).format("YYYY-MM-DD")
          );

          this.isLoading = false;
          this.$router.push({
            path: `clientes/periodo`,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async redirect() {
      if (this.verificaCampos()) {
        await this.geraAnaliseCompraAusencia();
      } else {
        const options = { title: "Algo deu errado...", size: "sm" };
        this.$dialogs.alert(
          "Preencha todos os campos antes de continuar.",
          options
        );
      }
    },

    verificaCampos() {
      if (this.datainicialcompras == null || this.datainicialcompras == "")
        return false;
      if (this.datafinalcompras == null || this.datafinalcompras == "")
        return false;
      if (this.datainicialausente == null || this.datainicialausente == "")
        return false;
      if (this.datafinalausente == null || this.datafinalausente == "")
        return false;
      if (this.compararProdutos)
        if (this.quantidadeComparada == null || this.quantidadeComparada == "")
          return false;
      return true;
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatInitialDate(date) {
      return moment(date).format("YYYY-MM-DD 00:00:00");
    },

    formatFinalDate(date) {
      return moment(date).format("YYYY-MM-DD 23:59:59");
    },

    mudaDataInicial(data) {
      if (data) {
        localStorage.removeItem("datainicial_compras");
        localStorage.setItem(
          "datainicial_compras",
          this.formatInitialDate(data)
        );

        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(data);
        this.disabledDatesEnd.from = new Date();
      }
    },

    mudaDataFinal(data) {
      if (data) {
        localStorage.removeItem("datacompra_final");
        localStorage.setItem("datafinal_compras", this.formatFinalDate(data));

        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(data);
      }
    },

    mudaDataInicialAusencia(data) {
      if (data) {
        localStorage.removeItem("datainicial_ausencia");
        localStorage.setItem(
          "datainicial_ausencia",
          this.formatInitialDate(data)
        );

        this.disabledDatesEndAusencia = {};
        this.disabledDatesEndAusencia.to = new Date(data);
        this.disabledDatesEndAusencia.from = new Date();
      }
    },

    mudaDataFinalAusencia(data) {
      if (data) {
        localStorage.removeItem("datafinal_ausencia");
        localStorage.setItem("datafinal_ausencia", this.formatFinalDate(data));

        this.disabledDatesStartAusencia = {};
        this.disabledDatesStartAusencia.from = new Date(data);
      }
    },

    fillDates() {
      if (!localStorage.getItem("datainicial_compras")) {
        localStorage.setItem(
          "datainicial_compras",
          moment().startOf("month").format("YYYY-MM-DD 00:00:00")
        );
      }
      if (!localStorage.getItem("datafinal_compras")) {
        localStorage.setItem(
          "datafinal_compras",
          moment().endOf("month").format("YYYY-MM-DD 23:59:59")
        );
      }
      if (!localStorage.getItem("datainicial_ausencia")) {
        localStorage.setItem(
          "datainicial_ausencia",
          moment().startOf("month").format("YYYY-MM-DD 00:00:00")
        );
      }
      if (!localStorage.getItem("datafinal_ausencia")) {
        localStorage.setItem(
          "datafinal_ausencia",
          moment().endOf("month").format("YYYY-MM-DD 23:59:59")
        );
      }

      this.datainicialcompras = localStorage.getItem("datainicial_compras");
      this.datafinalcompras = localStorage.getItem("datafinal_compras");
      this.datainicialausente = localStorage.getItem("datainicial_ausencia");
      this.datafinalausente = localStorage.getItem("datafinal_ausencia");

      this.disabledDatesStart = {};
      this.disabledDatesStart.from = new Date(this.datafinalcompras);

      this.disabledDatesEnd = {};
      this.disabledDatesEnd.to = new Date(this.datainicialcompras);
      this.disabledDatesEnd.from = new Date(this.dayafinalcompras);

      this.disabledDatesStartAusencia = {};
      this.disabledDatesStartAusencia.from = new Date(this.datafinalausente);

      this.disabledDatesEndAusencia = {};
      this.disabledDatesEndAusencia.to = new Date(this.datainicialausente);
      this.disabledDatesEndAusencia.from = new Date(this.dayafinalausente);
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.fillDates();
    this.isLoading = false;
  },
};
</script>
